import React from 'react'
import PropTypes from 'prop-types'

import FacebookAdsSection from './FacebookAdsSection'
import GoogleAdsSection from './GoogleAdsSection'
import DV360AdsSection from './DV360AdsSection'
import TikTokAdsSection from './TikTokAdsSection'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'

function AdsSection({ showSection }) {
  return (
    <>
      {showSection[FACEBOOK_PLATFORM] && <FacebookAdsSection />}
      {showSection[GOOGLE_PLATFORM] && <GoogleAdsSection />}
      {showSection[DV_360_PLATFORM] && <DV360AdsSection />}
      {showSection[TIKTOK_PLATFORM] && <TikTokAdsSection />}
    </>
  )
}

AdsSection.propTypes = {
  showSection: PropTypes.object.isRequired
}

export default AdsSection
